import React from 'react'
import { PricingData } from '../Data/PricingData'
import Card from './Card'

const Pricing = () => {
    return (
        <div className='pricing-container'>
            <div className='pricing-container-header'>
                <h1 className='section-heading'>Pricing</h1>
                <p>Codie is currently available as a free trial preview</p>
            </div>
            <div className='pricing-cards'>
                {PricingData.map((p, i) => (
                    <Card key={i} data={p} />
                ))}
            </div>
            <div className='pricing-btn'>
                <a href="https://forms.gle/SEDyXic3XqyyDsSH9" target='_blank' rel="noreferrer"><button>Get Early Access to Premium</button></a>
            </div>
        </div>
    )
}

export default Pricing